import React, { useContext } from 'react'
import AddRegion from '../components/BoligPrisKalkulator/AddRegion';
import EditRegions from '../components/BoligPrisKalkulator/EditRegions'
import AddRente from '../components/LoanCalculator/AddRente';
import EditRenter from '../components/LoanCalculator/EditRenter';
import StateContext from '../StateContext'

function AdminPage() {

    const appState = useContext(StateContext);

    return (
        <div className="container my-3">
            {appState.loggedIn && (
                <React.Fragment>

                    <h2>Legg til region</h2>
                    <AddRegion />
                    <hr />
                    <h2>Rediger regioner</h2>
                    <EditRegions />
                    <hr/>
                    <h2>Legg til rente</h2>
                    <AddRente />
                    <hr />
                    <h2>Rediger rentesatser</h2>
                    <EditRenter/>

                </React.Fragment>
            )}
            {!appState.loggedIn && <div className="alert alert-danger">Logg inn for å redigere</div>}

        </div>
    )

}
export default AdminPage